import { useNavigate } from "react-router-dom";
import { List, Search, Globe2, ChevronLeft, ChevronRight } from "lucide-react";
import { PageHeader } from "../components/common";
import PopularAirports from "../components/PopularAirports";
import SEOHead from "../components/SEOHead";
import { breadcrumbLd } from "../lib/structuredData";

export default function Airports() {
  const nav = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const q = new FormData(e.target).get("q")?.trim();
    nav(q ? `/airports/directory?q=${encodeURIComponent(q)}` : "/airports/directory");
  };

  return (
    <div data-testid="airports-page">
      <SEOHead
        title="Airports — World's Busiest Hubs & Full Profiles"
        description="Browse 85,000+ airports worldwide. Every profile links to terminals, routes, weather, maps, lounges and traveler community."
        canonical="/airports"
        jsonLd={breadcrumbLd([["Home", "/"], ["Airports"]])}
      />
      <PageHeader eyebrow="Directory" title="Airports"
        subtitle="The busiest airports in the US, Europe and worldwide — every airport links to its full profile with terminals, routes, weather and community." />
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col sm:flex-row gap-3 mb-4">
          <form onSubmit={submit} className="flex flex-1 gap-2">
            <input name="q" data-testid="airports-search"
              placeholder="Search 85,000+ airports by name, city or IATA code…"
              className="flex-1 border border-zinc-300 bg-white px-4 py-3 outline-none focus:ring-2 focus:ring-primary transition-colors" />
            <button type="submit" data-testid="airports-search-submit"
              className="inline-flex items-center gap-1.5 px-5 py-3 text-sm font-700 bg-primary text-white hover:bg-blue-700 transition-colors">
              <Search className="w-4 h-4" /> Search
            </button>
          </form>
          <button onClick={() => nav("/airports/directory")} data-testid="browse-airports-directory-btn"
            className="inline-flex items-center justify-center gap-1.5 px-5 py-3 text-sm font-700 border border-zinc-300 bg-white text-zinc-700 hover:border-primary hover:text-primary transition-colors">
            <List className="w-4 h-4" /> All Airports A–Z
          </button>
          <button onClick={() => nav("/airports/ranking")} data-testid="airports-global-ranking-btn"
            className="inline-flex items-center justify-center gap-1.5 px-5 py-3 text-sm font-700 border border-zinc-300 bg-white text-zinc-700 hover:border-primary hover:text-primary transition-colors">
            <Globe2 className="w-4 h-4" /> World's Busiest
          </button>
        </div>
        <PopularAirports />
      </div>
    </div>
  );
}

export const Pagination = ({ page, totalPages, setPage }) => (
  <div className="flex items-center justify-center gap-2 mt-10" data-testid="pagination">
    <button disabled={page <= 1} onClick={() => setPage(page - 1)}
      className="p-2 border border-zinc-300 bg-white disabled:opacity-40 hover:border-primary transition-colors" data-testid="page-prev">
      <ChevronLeft className="w-4 h-4" />
    </button>
    <span className="px-4 text-sm font-mono">Page {page} / {totalPages}</span>
    <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}
      className="p-2 border border-zinc-300 bg-white disabled:opacity-40 hover:border-primary transition-colors" data-testid="page-next">
      <ChevronRight className="w-4 h-4" />
    </button>
  </div>
);
